import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCmsHomeAction } from '../../../store/slices/cmsSlice';

const VisionSection = () => {
  // Responsive breakpoints state
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isLaptop, setIsLaptop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 600);
      setIsTablet(width <= 768);
      setIsLaptop(width <= 1024);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const dispatch = useDispatch();
  const cmsHome = useSelector((state) => state.cms.home);
  useEffect(() => {
    if (!cmsHome) dispatch(fetchCmsHomeAction());
  }, [cmsHome, dispatch]);

  const data = useMemo(() => {
    const arr = Array.isArray(cmsHome?.data) ? cmsHome.data : [];
    const section = arr.find((s) => s?.id === 86);
    const related = Array.isArray(section?.relatedCMS) ? section.relatedCMS : [];
    const rel = related[0] || {};
    return {
      title: section?.title || '',
      baseDescription: section?.description || '',
      secondDescription: rel?.description || '',
      images: [
        rel?.image || '',
        rel?.image2 || '',
        rel?.image3 || '',
      ],
    };
  }, [cmsHome]);

  const aboutPeopleIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
    </svg>
  );

  const DonateMonthlyImage1 = data.images[0];
  const DonateMonthlyImage2 = data.images[1];
  const DonateMonthlyImage3 = data.images[2];

  return (
    <div
      style={{
        backgroundColor: '#1D1D1B',
        display: 'flex',
        flexDirection: isTablet ? 'column-reverse' : 'row',
        gap: isMobile ? '20px' : '17px',
        padding: isLaptop ? '30px 16px 30px 16px' : '90px 0px 70px 70px',
        borderRadius: '30px',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      {/* Left Content Section */}
      <div>
        <h2
          style={{
            fontWeight: 600,
            fontSize: isMobile ? '16px' : isLaptop ? '18px' : '20px',
            lineHeight: isMobile ? '20px' : '42px',
            color: '#A9C74E',
            marginBottom: isTablet ? '10px' : '30px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            margin: `0 0 ${isTablet ? '10px' : '30px'} 0`
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {aboutPeopleIcon}
          </span>
          Who we are
        </h2>

        <h2
          style={{
            fontWeight: 700,
            fontSize: isMobile ? '18px' : isLaptop ? '22px' : '36px',
            lineHeight: isMobile ? '28px' : isLaptop ? '40px' : '50px',
            color: '#FFF',
            marginBottom: '20px',
            maxWidth: '620px',
            margin: '0 0 20px 0'
          }}
        >
          {data.title}
        </h2>

        <p
          style={{
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '24px',
            color: '#E8E8E8',
            paddingBottom: isTablet ? '12px' : '20px',
            display: 'block',
            maxWidth: '667px',
            margin: 0
          }}
        >
          {data.baseDescription}
        </p>

        <p
          style={{
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '24px',
            color: '#E8E8E8',
            display: 'block',
            maxWidth: '667px',
            paddingBottom: isTablet ? '20px' : '30px',
            margin: 0
          }}
        >
          {data.secondDescription}
        </p>

        <div style={{ textAlign: isTablet ? 'center' : 'left' }}>
          <button
            style={{
              backgroundColor: '#F04951',
              color: '#FFFFFF',
              padding: '15px 24px',
              borderRadius: '10px',
              fontWeight: 600,
              fontSize: '14px',
              lineHeight: '14px',
              textTransform: 'capitalize',
              cursor: 'pointer',
              textAlign: 'center',
              width: '183px',
              margin: isTablet ? '0 auto' : '0',
              border: 'none',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#d63447';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 24px rgba(240, 73, 81, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#F04951';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            Donate Now
          </button>
        </div>
      </div>

      {/* Right Images Section */}
      <div>
        <div
          style={{
            flex: '1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* Three Mask Images Container */}
          <div
            style={{
              width: isMobile ? '274px' : isTablet ? '350px' : isLaptop ? '450px' : '505px',
              height: isMobile ? '231px' : isTablet ? '300px' : isLaptop ? '380px' : '425px',
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {/* First Mask Image with Content */}
            {DonateMonthlyImage1 ? (
            <div
              style={{
                position: 'absolute',
                width: isMobile ? '144px' : isTablet ? '185px' : isLaptop ? '235px' : '265px',
                height: isMobile ? '176px' : isTablet ? '230px' : isLaptop ? '290px' : '324px',
                top: isMobile ? '20px' : isTablet ? '25px' : isLaptop ? '35px' : '50px',
                left: '0px',
                zIndex: 3,
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
              }}
            >
              <img
                src={DonateMonthlyImage1}
                alt="Monthly Donation Image 1"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>
            ) : null}
            
            {/* Second Mask Image with Content */}
            {DonateMonthlyImage2 ? (
            <div
              style={{
                position: 'absolute',
                width: isMobile ? '100px' : isTablet ? '170px' : isLaptop ? '220px' : '187px',
                height: isMobile ? '74px' : isTablet ? '95px' : isLaptop ? '120px' : '139px',
                top: isMobile ? '39px' : isTablet ? '52px' : isLaptop ? '68px' : '84px',
                right: isMobile ? '61px' : isTablet ? '55px' : isLaptop ? '74px' : '110px',
                zIndex: 2,
                borderRadius: '15px',
                overflow: 'hidden',
                boxShadow: '0 6px 24px rgba(0,0,0,0.25)'
              }}
            >
              <img
                src={DonateMonthlyImage2}
                alt="Monthly Donation Image 2"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>
            ) : null}
            
            {/* Third Mask Image with Content */}
            {DonateMonthlyImage3 ? (
            <div
              style={{
                position: 'absolute',
                width: isMobile ? '130px' : isTablet ? '125px' : isLaptop ? '165px' : '240px',
                height: isMobile ? '84px' : isTablet ? '125px' : isLaptop ? '165px' : '155px',
                bottom: isMobile ? '1px' : isTablet ? '5px' : isLaptop ? '-3px' : '-13px',
                left: isMobile ? '80px' : isTablet ? '105px' : isLaptop ? '132px' : '146px',
                zIndex: 1,
                borderRadius: '15px',
                overflow: 'hidden',
                boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
              }}
            >
              <img
                src={DonateMonthlyImage3}
                alt="Monthly Donation Image 3"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisionSection;